import OpenInNew from "@material-symbols/svg-500/rounded/open_in_new.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const OpenInNewIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: OpenInNew });
	return <Icon />;
};

export default memo(OpenInNewIcon);
